import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_APP = gql`
  mutation createApp(
    $title: String!
    $identifier: String!
    $applicationDescription: String! # $logoId: String!
  ) {
    app {
      submitApp(
        inputType: {
          title: $title
          identifier: $identifier
          applicationDescription: $applicationDescription
          # logoId: $logoId
        }
      ) {
        id
      }
    }
  }
`;

const CreateAppRequest = ({
  title,
  identifier,
  onError,
  onSuccessResult,
  applicationDescription,
  // logoId,
}) => (
  <Mutation mutation={CREATE_APP}>
    {(createApp, { loading, error, data }) => {
      const variables = {
        title,
        identifier,
        applicationDescription,
        // logoId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.app.submitApp);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createApp}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

CreateAppRequest.propTypes = {
  applicationDescription: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  identifier: PropTypes.string.isRequired,
  // logoId: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

CreateAppRequest.defaultProps = {};

export default CreateAppRequest;
